import { Controller } from "@hotwired/stimulus"

const CSS_CLASSES = {
  isAttached: "is--attached"
}

export default class extends Controller {
  static targets = ["previewImage"]

  handleFileInputChange(event) {
    const file = event.target.files[0]
    if (!file) { return }

    this.element.classList.add(CSS_CLASSES.isAttached)

    const reader = new FileReader()
    reader.onload = () => { this.previewImageTarget.src = reader.result }
    reader.readAsDataURL(file)
  }
}
